import * as React from 'react';

import classnames from 'classnames';

import {Metric} from './metric';
import type {MetricType} from './metric';

import styles from './metrics.module.css';

type Props = {
    stats: MetricType &
        {
            key: string;
        }[];
    size?: 'small' | 'normal' | 'big';
    hasBorders?: boolean;
};

export function StatsBlockVertical(props: Props) {
    const {size = 'big', hasBorders = true} = props;

    return (
        <div
            className={classnames(
                'flex-dir-col',
                hasBorders ? styles.container : styles['container--no-border']
            )}
        >
            {props.stats.map((stat, index) => {
                return (
                    <React.Fragment key={stat.key}>
                        {index !== 0 ? <div className={styles['divider-horizontal']} /> : undefined}
                        <div
                            className={
                                size === 'normal'
                                    ? styles['stat-container-vertical--normal']
                                    : styles['stat-container-vertical']
                            }
                        >
                            {/* @ts-expect-error */}
                            <Metric {...stat} size={size} />
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}
